import axiosIns from '@/plugins/axios'

export default {
  // 顧客のノミネーション集計を取得
  getCustomerNominationStats(customerId) {
    return axiosIns.get(`/waiter/customers/${customerId}/nomination_stats`)
  },
}
